export const HOME_V2_COMMENT_ICON_HEIGHT = 14;
export const HOME_V2_COMMENT_ICON_WIDTH = 13.2;
